import AuthPage, { AuthMode } from './AuthPage'

/**
 * LoginPage Component
 *
 * Renders the sign-in variant of the shared AuthPage.
 * See AuthPage for layout and appearance config.
 */
const LoginPage = () => <AuthPage mode={AuthMode.SIGN_IN} />

export default LoginPage
